<div class="popup-container">
    <div class="centered-div" *ngIf="loading">
        <mat-spinner [color]="'primary'" [diameter]="50"></mat-spinner>

    </div>
    <ng-container>
        <h2 class="title">Delete {{data.type||type||'Report'}}</h2>
        <p class="message">
            Are you sure you want to delete this report? This action cannot be undone. </p>

        <div class="button-container">

            <button mat-button class="cancel-button" (click)="cancel()">Cancel</button>
            <button mat-button class="force-button" (click)="ConfirmDelete()">Delete</button>
        </div>
    </ng-container>
</div>